export default {
  scenes: {
    flightOfDesperation: {
      beats: {
        chasingGhosts: {
          events: [
            {
              type: 'showLocation',
              locationId: 'airplane'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'thinking',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'What does Reina believe before she lands?',
              choices: [
                {
                  text: 'She Thinks He Still Cares',
                  next: {
                    scene: 'flightOfDesperation',
                    beat: 'sheThinksCares'
                  }
                },
                {
                  text: 'She Just Wants Closure',
                  next: {
                    scene: 'flightOfDesperation',
                    beat: 'sheWantsClosure'
                  }
                }
              ]
            }
          ]
        },
        sheThinksCares: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'Maybe he\'s just scared. Maybe he needs to hear me say it first.'
            },
            {
              type: 'showNarration',
              text: 'She grips her seat, heart pounding with anticipation.'
            },
            {
              type: 'showEffect',
              effect: 'screenShake',
              intensity: 5,
              duration: 0.5,
              waitUntilFinish: true
            }
          ],
          next: {
            scene: 'flightOfDesperation',
            beat: 'addressFeelsFinal'
          }
        },
        sheWantsClosure: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'I just need the truth. Even if it hurts.'
            },
            {
              type: 'showNarration',
              text: 'She stares out of the window, preparing for whatever comes next.'
            }
          ],
          next: {
            scene: 'flightOfDesperation',
            beat: 'addressFeelsFinal'
          }
        },
        addressFeelsFinal: {
          events: [
            {
              type: 'showLocation',
              locationId: 'ericsApartment'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'thinking',
              position: 'center'
            },
            {
              type: 'showNarration',
              text: 'After landing, Reina goes straight to his apartment. But something feels… wrong. She hesitates before knocking.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: 'What if I regret this?'
            }
          ],
          next: {
            scene: 'doorShouldntOpen',
            beat: 'someoneElseAnswers'
          }
        }
      }
    },
    doorShouldntOpen: {
      beats: {
        someoneElseAnswers: {
          events: [
            {
              type: 'showNarration',
              text: 'When the door swings open, it\'s not Eric standing there. It\'s a woman. She looks comfortable, like she lives here.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'How does Reina react?',
              choices: [
                {
                  text: 'Stumble Over Her Words',
                  next: {
                    scene: 'doorShouldntOpen',
                    beat: 'stumbleWords'
                  }
                },
                {
                  text: 'Ask Directly',
                  next: {
                    scene: 'doorShouldntOpen',
                    beat: 'askDirectly'
                  }
                }
              ]
            }
          ]
        },
        stumbleWords: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'surprised',
              text: 'I—sorry, I must have the wrong place…'
            },
            {
              type: 'showCharacter',
              characterId: 'woman',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'woman',
              variation: 'happy',
              text: 'You looking for Eric?'
            }
          ],
          next: {
            scene: 'doorShouldntOpen',
            beat: 'confirmation'
          }
        },
        askDirectly: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'Is Eric here?'
            },
            {
              type: 'showCharacter',
              characterId: 'woman',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'woman',
              variation: 'neutral',
              text: 'Yeah. Hold on a sec.'
            }
          ],
          next: {
            scene: 'doorShouldntOpen',
            beat: 'confirmation'
          }
        },
        confirmation: {
          events: [
            {
              type: 'showNarration',
              text: 'Eric steps into the doorway, expression unreadable. He sees Reina, and for a split second, there\'s something—guilt? Surprise? But then, his face hardens.'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'neutral',
              text: 'What are you doing here?'
            }
          ],
          next: {
            scene: 'answerNeverWanted',
            beat: 'truthOrLie'
          }
        }
      }
    },
    answerNeverWanted: {
      beats: {
        truthOrLie: {
          events: [
            {
              type: 'showLocation',
              locationId: 'ericsApartmentOutside'
            },
            {
              type: 'showNarration',
              text: 'They step outside, standing in the cold air. Reina stares at him, waiting for something, anything that makes sense.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'How does Reina demand answers?',
              choices: [
                {
                  text: 'Beg for an Explanation',
                  next: {
                    scene: 'answerNeverWanted',
                    beat: 'begExplanation'
                  }
                },
                {
                  text: 'Stay Composed, Even If It Hurts',
                  next: {
                    scene: 'answerNeverWanted',
                    beat: 'stayComposed'
                  }
                }
              ]
            }
          ]
        },
        begExplanation: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: 'I don\'t understand. What happened to us?'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'neutral',
              text: 'There was no \'us,\' Reina.'
            }
          ],
          next: {
            scene: 'answerNeverWanted',
            beat: 'finalCut'
          }
        },
        stayComposed: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'Just tell me the truth.'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'neutral',
              text: 'I moved on. You should too.'
            }
          ],
          next: {
            scene: 'answerNeverWanted',
            beat: 'finalCut'
          }
        },
        finalCut: {
          events: [
            {
              type: 'showNarration',
              text: 'Eric looks at her, and for a moment, she thinks she sees something crack in his expression. But then, he delivers the final blow.'
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'sad',
              text: 'What we had… it wasn\'t real.'
            },
            {
              type: 'showNarration',
              text: 'Her breath catches. The world tilts. Everything she fought for, everything she believed—it shatters in an instant.'
            },
            {
              type: 'showEffect',
              effect: 'screenShake',
              intensity: 10,
              duration: 1,
              waitUntilFinish: true
            }
          ],
          next: {
            scene: 'walkingAwayWithNothing',
            beat: 'lastLook'
          }
        }
      }
    },
    walkingAwayWithNothing: {
      beats: {
        lastLook: {
          events: [
            {
              type: 'showLocation',
              locationId: 'hotelRoom'
            },
            {
              type: 'showNarration',
              text: 'Reina doesn\'t remember how she gets back to her hotel. She only remembers walking away, the sound of her footsteps too loud in the empty street.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'How does Reina handle the pain?',
              choices: [
                {
                  text: 'Break Down Completely',
                  next: {
                    scene: 'walkingAwayWithNothing',
                    beat: 'breakDown'
                  }
                },
                {
                  text: 'Numbly Accept It',
                  next: {
                    scene: 'walkingAwayWithNothing',
                    beat: 'numbAccept'
                  }
                }
              ]
            }
          ]
        },
        breakDown: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'crying',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'crying',
              text: 'I was so stupid.'
            },
            {
              type: 'showNarration',
              text: 'She curls up in her hotel bed, unable to sleep, unable to breathe.'
            }
          ],
          next: {
            scene: 'walkingAwayWithNothing',
            beat: 'hollowMorning'
          }
        },
        numbAccept: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'sad',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: 'This is how it ends.'
            },
            {
              type: 'showNarration',
              text: 'She stares at the city lights, too exhausted to cry.'
            }
          ],
          next: {
            scene: 'walkingAwayWithNothing',
            beat: 'hollowMorning'
          }
        },
        hollowMorning: {
          events: [
            {
              type: 'showLocation',
              locationId: 'airplane'
            },
            {
              type: 'showNarration',
              text: 'The next morning, Reina boards her flight home. She doesn\'t look back. There\'s nothing left to see.'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'thinking',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'Maybe I was just something temporary to him.'
            },
            {
              type: 'showNarration',
              text: 'THE END.'
            }
          ],
          goToGameOver: true
        }
      }
    }
  }
}
